package com.exura.features.fileStorage.data.repository

import com.exura.features.fileStorage.domain.repository.UserFileStorageRepository
import com.exura.features.firebase.usecase.GetUserFilesPrefixUseCase
import dev.gitlive.firebase.storage.File
import dev.gitlive.firebase.storage.FirebaseStorage
import dev.gitlive.firebase.storage.StorageReference

class UserFileStorageRepositoryImpl(
    private val storage: FirebaseStorage,
    private val getUserFilesPrefixUseCase: GetUserFilesPrefixUseCase,
) : UserFileStorageRepository {
    override suspend fun fetchFiles(path: String) : Result<List<StorageReference>> = runCatching {
        val prefix = getUserFilesPrefixUseCase().getOrThrow()
        val fileListPrefix = prefix.child(path)
        fileListPrefix.listAll().items

    }
    override suspend fun uploadFile(pathPrefix: String, filename: String, file: File) : Result<StorageReference> = runCatching {
        val prefix = getUserFilesPrefixUseCase().getOrThrow()
        val fileListPrefix = prefix.child(pathPrefix).child(filename)
        fileListPrefix.putFile(file)
        fileListPrefix
    }
}
